import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ButtonModel } from './button.model';
import { keyframes } from '@angular/animations';
import { Key } from 'protractor';
declare var $: any;

@Component({
    selector: 'app-richtext',
    templateUrl: './richtext.component.html'
})
export class RichTextComponent implements OnInit {
    @Input() id = 'summernote';
    @Input() buttons: ButtonModel[];
    @Input() height = 600;
    @Input() disableFullscreen: boolean = false;
    @Input() mentionsEnabled: boolean = false;
    // public content: string;

    private userMentions: any[] = [];

    ngOnInit() {
        let cachedMentions = this.mentionsEnabled ? localStorage.getItem('userMentions') : '[]';
        this.userMentions = JSON.parse(cachedMentions || '[]');

        $(`#${this.id}`).summernote({
            height: this.height,
            dialogsInBody: true,
            followingToolbar: false,
            callbacks: {
                // onChange: (content, $editable) => {
                // this.content = content;
                // }
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', [ this.disableFullscreen ? '' : 'fullscreen', 'codeview', 'help']],
            ],
            fontSizeUnits: ['px'],
            hint: {
                mentions: this.userMentions,
                match: /\B@([a-z ]*)/i,
                search: function (keyword, callback) {
                    callback(
                        this.mentions.filter(function(item){return item.name.toLowerCase().indexOf(keyword)>-1 || item.email.toLowerCase().indexOf(keyword)>-1;})
                    );
                },
                template: function(item) {
                    return item.name;
                },
                content: function (item) {
                    return  $('<a>')
                    .attr('href', '')
                    .attr('title', item.email)
                    .text('@' + item.name)
                    .get(0);
                }
            }
        });

        $('.note-popover').css({
            'display': 'none'
        });

        // $(`#${this.id}`).summernote({
        //     callbacks: {
        //         onPaste: function (e, ne) {
        //             console.log('Called event paste');
        //         }
        //     }
        // });

        // // summernote.paste
        // $(`#${this.id}`).on('summernote.paste', function (e, ne) {
        //     console.log('Called event paste');

        //     var data = ((ne.originalEvent || ne).clipboardData || (window as any).clipboardData);
        //     // var text: string = data.getData('text/plain');
        //     var html: string = data.getData('text/html');
        //     // var rtf: string = data.getData('text/rtf');

        //     e.preventDefault();
        //     // console.log('RTF:');
        //     // console.log(rtf);
        //     // console.log('HTML:');
        //     // console.log(html);

        //     var length = html.length;
        //     var index = 0;


        //     var imagesArray = $(html).find("img").map(function () {
        //         return $(this).html();
        //     }).get();

        //     console.log(imagesArray);


        //     while (index < length) {
        //         var newIndex = html.indexOf("<img", index);

        //         if (newIndex === -1) {
        //             break;
        //         }
        //         else {
        //             index = newIndex;

        //             var endingIndex = html.indexOf(">", index);

        //             var imgString = html.substr(newIndex, endingIndex - newIndex + 1);

        //             var url = $(imgString).attr('src');

        //             // tu dostajemy url 
        //             console.log(url);

        //             index = endingIndex;
        //         }
        //     }
        // });

        // addEventListener('keydown', x => { this.convert(x.ctrlKey, x.altKey, x.keyCode); });
    }

    // public convert(isCtrl, isAlt, key) {
    //     if (!(isAlt && isCtrl && key === 86)) {
    //         return;
    //     }

    //     console.log("Test");
    // }

    public getHtml() {
        return $(`#${this.id}`).summernote('code');
    }

    public reset() {
        $(`#${this.id}`).summernote('reset');
    }

    public insertHtml(text: string) {
        $(`#${this.id}`).summernote('code', text);
    }

    public setHtml(text: string) {
        this.reset();
        this.insertHtml(text);
    }

    public insertText(text: string) {
        $(`#${this.id}`).summernote('insertText', text);
    }

    public setText(text: string) {
        this.reset();
        this.insertText(text);
    }

    public disableContol() {
        $(`#${this.id}`).summernote('disable');
    }

    public enableContol() {
        $(`#${this.id}`).summernote('enable');
    }

    public isEmpty(data: string) {
        data = this.replaceAll(data, '<p>', '');
        data = this.replaceAll(data, '</p>', '');
        data = this.replaceAll(data, '&nbsp;', '');
        data = this.replaceAll(data, '<br>', '');
        return data.trim() === '' ? true : false;
    }

    private replaceAll(str, find, replace) {
        while (str.includes(find)) {
            str = str.replace(new RegExp(find, ''), replace);
        }
        return str;
    }
}
